<div class="preview">
  <div class="header">
    <h3>{{plan.name_plan | dynamicTranslate}}</h3><img src="/assets/icons/etiqueta.svg" alt="">
    <!-- <img src="../../../assets/icons/etiqueta-celeste.png" alt=""> -->
  </div>
  <div class="see-photo">
    <img [src]="imagePath || '../../../assets/icons/photo.png'" alt="foto">
  </div>
  <h3>{{ 'Beneficio principal' | dynamicTranslate }}</h3>
  <h1 class="big-number">${{plan.feeCost_plan}}</h1>
  <h4>{{plan.frecuency.name_frecuency | dynamicTranslate}}</h4>
  <div class="including">
    <h5 class="dotted-list">
      <li>{{plan.description | dynamicTranslate}}</li>
      <!-- <li>Sunde omnis iste natus</li>
      <li>Sed ut perspiciatis unde omnis iste natus sit</li> -->
    </h5>
  </div>

  <div class="options">
    <button class="edit-bt" (click)="goEdit()" [disabled]="plan.type == 0" [ngClass]="{'disabled': plan.type == 0}"> <img src="../../../assets/icons/editar.png" alt="editar plan">
      <p>{{ 'Editar' | dynamicTranslate }}</p>
    </button>
    @if (plan.status_plan == 2) {
      <button (click)="onUpdateStatus(plan.id,1)"> <img src="../../../assets/icons/ok.png" alt="activar plan">
        <p>{{ 'Activar' | dynamicTranslate }}</p>
      </button>
    }
    @if (plan.status_plan == 1) {
      <button (click)="onUpdateStatus(plan.id,2)" [disabled]="plan.type == 0" [ngClass]="{'disabled': plan.type == 0}"> <img src="../../../assets/icons/eliminar.png" alt="desactivar plan">
        <p>{{ 'Desactivar' | dynamicTranslate }}</p>
      </button>
    }
  </div>
</div>